(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.CreativeServices",
            {
                url: "/CreativeServices",
                component: "creativeservices",
                PageTitle: "Creative Services"
            });
        }
    ]);

    app.component("creativeservices",
    {
        templateUrl: "App/Tools/MarketPlace/CreativeServices/CreativeServices.html",
        controller: creativeServicesCtrl
    });

    creativeServicesCtrl.$inject = ["$mdDialog", "eligibilityFormApi", "surveys", "eligibilityFormDialog", "externalLoading", "amplitudeService", "surveyRenewalDialog"];

    function creativeServicesCtrl($mdDialog, eligibilityFormApi, surveys, eligibilityFormDialog, externalLoading, amplitudeService, surveyRenewalDialog) {
        var $ctrl = this;     

        ng.extend($ctrl,
            {
                loading: true,
                intervals: [],
                submitted: false,
                pendingRenewal: false,
                hasPastRenewals: false,
                surveyId: null,
                openSurveyRenewalDialog: openSurveyRenewalDialog,
                getAndRefreshSurveyRenewals: getAndRefreshSurveyRenewals,
                openDialog: openDialog,
                logAmplitude: logAmplitude,
                init: init
            });

        function init() {
            surveys.then(function (s) {

                $ctrl.surveyId = s.creativeServicesId;

                $ctrl.getAndRefreshSurveyRenewals().then(function () {
                    if ($ctrl.pendingRenewal)
                        $ctrl.openSurveyRenewalDialog();
                });

                eligibilityFormApi.isEnrolled(s.creativeServicesId).then(function (response) {
                    $ctrl.submitted = response;
                });

            }).then(function () { $ctrl.loading = false; });
        }

        function openSurveyRenewalDialog() {
            surveyRenewalDialog.open(event, $ctrl.surveyRenewals, $ctrl.surveyId).then(function (obj) {
                ng.extend($ctrl, obj);
            }).then(function () {
                $ctrl.getAndRefreshSurveyRenewals();
            });
        }

        function getAndRefreshSurveyRenewals() {

            return eligibilityFormApi.getSurveyRenewals($ctrl.surveyId).then(function (results) {
                $ctrl.surveyRenewals = results;
                var renewal = _.find(results, function (renewal) { return renewal.SurveyId === $ctrl.surveyId; });
                if (renewal) {
                    if (renewal.SurveyRenewalStatusId === 1) {
                        $ctrl.pendingRenewal = true;
                    }
                    else {
                        $ctrl.pendingRenewal = false;
                        $ctrl.hasPastRenewals = true;
                    }
                }

            }, function () {
                return null;
            });
        }
      
        /*  Open the Enrollment Form  */
        function openDialog(event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.creativeServicesId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        function logAmplitude(propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        }

        $ctrl.init();
    }
})(window.app, window.angular); // jshint ignore:line